
import { Vue } from "vue-class-component";

export default class ClockWarning extends Vue {}
